<div class="client-page-content">
  <div class="content-header">
    <h2>{{ 'CLIENT.clientStores.title' | translate }}</h2>
  </div>
  <ul class="options" *ngIf="!loading">
    <ng-container *ngFor="let store of stores">
      <li (click)="selectStore(store)" *ngIf="store.status === 'open'">
        <div class="d-flex justify-content-between align-items-center">
          <div class="">
            <a class="option">{{store?.name}}</a>
          </div>
          <div class="text-right" data-nosnippet>
            <span><i class="material-icons icon">keyboard_arrow_right</i></span>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>
  <app-loader-list-placeholder *ngIf="loading"></app-loader-list-placeholder>
</div>
